import { message as antdMessage, Button, Form, FormProps, Input } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { buildApiUrl } from '@/global';
import { usePost } from '@/shared/hook/usePost';
import AuthLayout from './AuthLayout';

type FieldType = {
  newPassword?: string;
  confirmPassword?: string;
};

type ResetConfirmResponse = {
  resultado?: boolean;
  mensaje?: string;
};

type ResetConfirmRequest = {
  clave: string;
  c: string;
  f: string;
  m: string;
};

const ResetPassword: React.FC = () => {
  const navigate = useNavigate();
  const [messageApi, contextHolder] = antdMessage.useMessage();
  const [params] = useSearchParams();
  const [ready, setReady] = useState(false);

  const postReset = usePost(buildApiUrl('/Cuenta/cambia-contrasenia'));

  const [resetParams, setResetParams] = useState<ResetConfirmRequest | null>(null);

  useEffect(() => {
    const c = params.get('c'); // Código
    const f = params.get('f'); // Fecha
    const m = params.get('m'); // Email

    if (c && f && m) {
      setResetParams({ clave: '', c, f, m });
      setReady(true);
    } else {
      messageApi.error('URL inválida o incompleta.');
      navigate('/login');
    }
  }, [params, navigate]);

  const onFinish: FormProps<FieldType>['onFinish'] = async (data) => {
    if (data.newPassword !== data.confirmPassword) {
      messageApi.error('Las contraseñas no coinciden.');
      return;
    }

    if (!resetParams) {
      messageApi.error('Error en los parámetros.');
      return;
    }

    try {
      const body = {
        correo: resetParams.m,
        codigo: resetParams.c,
        pass: data.newPassword!,
      };

      const response = (await postReset.postData(body)) as ResetConfirmResponse;

      if (response?.resultado) {
        messageApi.success(response.mensaje || 'Contraseña restablecida con éxito.');
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      } else {
        messageApi.error(response?.mensaje || 'No se pudo restablecer la contraseña.');
      }
    } catch (err: unknown) {
      const errorMsg = err instanceof Error ? err.message : String(err);
      messageApi.error('Error al conectar con el servidor. ' + errorMsg);
    }
  };

  return (
    <Fragment>
      {contextHolder}
      <AuthLayout title="Restablece tu contraseña" hint="Ingresa tu nueva contraseña para recuperar el acceso.">
        {ready && (
          <Form name="recover" layout="vertical" onFinish={onFinish} autoComplete="off">
            <Form.Item<FieldType>
              label="Nueva Contraseña"
              name="newPassword"
              rules={[
                { required: true, message: 'Por favor ingresa tu nueva contraseña' },
                { min: 6, message: 'La contraseña debe tener al menos 6 caracteres' },
              ]}
            >
              <Input.Password placeholder="********" />
            </Form.Item>

            <Form.Item<FieldType>
              label="Confirmar Contraseña"
              name="confirmPassword"
              dependencies={['newPassword']}
              rules={[
                { required: true, message: 'Por favor confirma tu contraseña' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Las contraseñas no coinciden'));
                  },
                }),
              ]}
            >
              <Input.Password placeholder="********" />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
                Restablecer Contraseña
              </Button>
            </Form.Item>
          </Form>
        )}
      </AuthLayout>
    </Fragment>
  );
};

export default ResetPassword;
